export default {"src":"/_next/static/media/excel.4561fc6f.svg","height":512,"width":513};